import { Snackbar, Alert } from '@mui/material';
import React from 'react';

interface NotificationProps {
  message: string;
  severity: 'success' | 'error' | 'warning' | 'info';
  open: boolean;
  onClose: () => void;
}

export function Notifications({ message, severity, open, onClose }: NotificationProps) {
  const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    onClose();
  };

  return (
    <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
      <Alert onClose={handleClose} severity={severity} variant='filled' sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
}
